import React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FormGroup } from "components/bootstrap";
import useDataLakeTableOptions from "data-lake/preview/storage-types/external/hooks/useDataLakeTableOptions";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { Select } from "components/common";
import StyledLabel from "data-lake/components/DataLakeActionModals/StyledLabel";
const Container = styled(FormGroup)`
  flex: 1;
  grid-area: table;
`;
const TableFilter = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const { selectedDataLake } = useSelectedDataLake();
  const { data, isLoading } = useDataLakeTableOptions(selectedDataLake == null ? void 0 : selectedDataLake.id);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, t("table_filter.label")), /* @__PURE__ */ React.createElement(Field, { name: "streamIds" }, ({ field: { value, onChange, name }, meta: { error } }) => /* @__PURE__ */ React.createElement(Container, { "data-testid": "streamIds-filter", validationState: error ? "error" : void 0, bsClass: "no-bm" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: t("table_filter.placeholder"),
      displayKey: "key",
      inputId: "streamIds-filter",
      value: value == null ? void 0 : value[0],
      options: data,
      multi: false,
      onChange: (newVal) => {
        onChange({ target: { value: [newVal], name } });
      },
      isLoading
    }
  ))));
};
export default TableFilter;
